import { useAAPlugin } from './useAAPlugin';

export const useSmartAccount = () => {
  const smartAccount = useAAPlugin((state) => state.smartAccount);
  return smartAccount;
};
